export const CHANGE_FONT_SIZE = 'CHANGE_FONT_SIZE';

export const changeFontSize = (fontSize = 12) => ({
    type: CHANGE_FONT_SIZE,
    payload: {fontSize: fontSize}
});
